var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.showheader)?_c('gnetHeader',{attrs:{"logo":_vm.$store.state.logoimage}}):_vm._e(),_c('gnetTabBar',{attrs:{"titoloapp":'Portale Clienti',"tabs":_vm.$store.state.tabs,"active_tab":_vm.$store.state.active_tab},on:{"click":function($event){return _vm.changeTab($event)}}}),_c('homehelp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }